module.exports = __webpack_public_path__ + "static/media/Pic-02.20bb9ef7.jpg";